var path = 'entity/entity-filter-view.tpl.html';
var html = " <div layout=column class=tb-entity-filter-view> <div ng-if=\"!filter || !filter.type\" class=entity-filter-empty translate>alias.no-entity-filter-specified</div> <div ng-if=\"filter && filter.type\" layout=column> <div class=entity-filter-value>{{ filterDisplayValue }}</div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/entity/entity-filter-view.tpl.html
// module id = 1464
// module chunks = 1